import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Suspense, useCallback, useState } from "react";
import a11yProps from "../../../constants/tabPanelProps/ayProps";
import TabPanel from "../../shared/tabPanelComponent/TabPanel";
import AddRecord from "./AddRecord";
import Topbar from "../../shared/topbar/Topbar";
import useRouteParam from "../../../hooks/useRouteParam";
import { GROUP_LIST_OBJECT } from "../../../constants/groupList/GroupList";
import { Badge, Tab, Tabs, withStyles } from "@material-ui/core";
import { LazyAddRecord, LazyNotes } from "../../lazyComponents/LazyComponent";
import { INote } from "../../../@types/components/notes.types";
import { api } from "../../../utils/api";
import useQuery from "../../../hooks/useQuery";
import { formatClaimNumber } from "../../../utils/commonFunctions/formatClaimNumber";

const StyledBadge = withStyles((theme: any) => ({
	badge: {
		backgroundColor: "#d2d8f9",
		color: "#060c2d",
		fontWeight: "bold",
		// boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		top: 3,
		left: -15,
		"&::after": {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			borderRadius: "50%",
			// animation: "$ripple 1.2s infinite ease-in-out",
			// border: "1px solid currentColor",
			// eslint-disable-next-line quotes
			content: '""'
		}
	},
	"@keyframes ripple": {
		"0%": {
			transform: "scale(.8)",
			opacity: 1
		},
		"100%": {
			transform: "scale(2.4)",
			opacity: 0
		}
	}
}))(Badge);

const Record = () => {
	const query = useQuery();
	const [claimId, setClaimId] = useState<string>("");
	const [claimNumber, setClaimNumber] = useState<string | null>(null);
	const [userObjectId, setUserObjectId] = useState<string>("");
	const [firstName, setFirstName] = useState<string>("");
	const [lastName, setLastName] = useState<string>("");
	const [notes, setNotes] = useState<INote[]>([]);

	const handleGetNotes = useCallback(async () => {
		const filter = {
			claim_object_id: claimId
		};
		const response = await api.notes.getNotes(filter);
		const notesWithEditableFalse = response.map((note: any) => ({
			...note,
			editable: false
		}));

		setNotes(notesWithEditableFalse);
	}, [claimId]);

	const [tabLabel, setTabLabel] = useState<number>(0);
	const groupNumber = useRouteParam("gn");
	const group = GROUP_LIST_OBJECT.get(Number(groupNumber) || 220);

	const handleLabelChange = useCallback((event: any, value: number) => {
		setTabLabel(value);
	}, []);

	useEffect(() => {
		if (claimId != "") {
			handleGetNotes();
		}
	}, [handleGetNotes, claimId]);

	useEffect(() => {
		if (query && query.get("id") !== null && query.get("id") !== undefined) {
			setClaimId(query.get("id") as string);
			if (query.get("claim_number")) {
				setClaimNumber(query.get("claim_number"));
			}
		}
	}, [query]);

	useEffect(() => {
		const user = localStorage.getItem("@user");
		if (user) {
			const { _id, first_name, last_name } = JSON.parse(user);
			setUserObjectId(_id);
			setFirstName(first_name);
			setLastName(last_name);
		}
	}, []);

	return (
		<div className="record">
			<div style={{ padding: 30, paddingTop: 0 }}>
				<Topbar />
				{groupNumber ? (
					<div className="logo" style={{ marginTop: 60 }}>
						<img src={group.logo} />
					</div>
				) : null}
			</div>
			<Box sx={{ width: "100%" }}>
				<Box sx={{ borderBottom: "none", padding: 4, paddingBottom: 0 }}>
					<Tabs
						value={tabLabel}
						onChange={handleLabelChange}
						TabIndicatorProps={{
							style: {
								border: "none",
								background: "blueViolet"
							}
						}}
						variant="scrollable"
						scrollButtons="auto"
						aria-label="scrollable auto tabs example"
						className="glb-tab-panel-green"
					>
						<Tab
							label={"Claim Details"}
							className="glb-tab-label"
							{...a11yProps(0)}
							style={{ fontWeight: "bold", fontSize: "1rem", textTransform: "capitalize" }}
						/>
						<Tab
							label={
								<StyledBadge
									anchorOrigin={{
										vertical: "top",
										horizontal: "left"
									}}
									variant="standard"
									badgeContent={notes.length}
								>
									Notes
								</StyledBadge>
							}
							className="glb-tab-label"
							{...a11yProps(1)}
							style={{ fontWeight: "bold", fontSize: "1rem", textTransform: "capitalize" }}
						/>
					</Tabs>
				</Box>

				<TabPanel value={tabLabel} index={0}>
					<Suspense fallback>
						<LazyAddRecord />
					</Suspense>
				</TabPanel>
				<TabPanel value={tabLabel} index={1}>
					<Suspense fallback>
						{/* dashboard ag grid */}
						<LazyNotes
							notes={notes}
							claimObjectid={claimId}
							userObjectId={userObjectId}
							claimNumber={claimNumber}
							setNotes={setNotes}
							first_name={firstName}
							last_name={lastName}
							key={0}
						/>
					</Suspense>
				</TabPanel>
			</Box>
		</div>
	);
};

export default Record;
